import React, { PureComponent, Fragment  } from 'react';

/**
 *
 */
class Counter  extends PureComponent{

    constructor( props ) {
        super( props );
        this.state = {
            count: 0
        };
        this.countInterval;
        this.increment = 1;
    }

    componentDidMount() {
        this.props.to && this.launchAnimation();
    }

    componentDidUpdate( prevProps ) {
        prevProps.to !== this.props.to && this.launchAnimation();
    }

  launchAnimation = () => {
        const { to, duration = 30 } = this.props;
        this.increment = Math.ceil( to / duration );
        clearInterval( this.countInterval );
        this.countInterval = setInterval( this.tick, duration );
    };

  tick = () => {
        const { to } = this.props;
        if ( this.state.count + this.increment >= to ) {
            this.setState( { count: to } );
            return clearInterval( this.countInterval );
        }
        return this.setState( { count: this.state.count + this.increment } );
    }

    render() {
        return <Fragment>{ this.state.count }</Fragment>;
    }

}

export default  Counter;